import { useCallback, useEffect, useRef, useState } from 'react';
import { needsUnlock, verifyFace } from './lock';
import { Logo } from '../components/Logo';

/*
 * Шторка Face ID в приложении для iPhone — вместо выхода по бездействию
 * (спека 2026-10-07-ios-app-design, §4). Закрывает интерфейс, ничего не
 * перезагружая: под ней всё как было. Вид — экран входа.
 */
export function AppLock({ startLocked, onLogout }: { startLocked: boolean; onLogout: () => void }) {
  const [locked, setLocked] = useState(startLocked);
  const [failed, setFailed] = useState(false);
  const hiddenAt = useRef<number | null>(null);

  const unlock = useCallback(async () => {
    setFailed(false);
    if (await verifyFace()) setLocked(false);
    else setFailed(true);
  }, []);

  useEffect(() => {
    if (startLocked) void unlock();
  }, [startLocked, unlock]);

  useEffect(() => {
    const onChange = () => {
      if (document.visibilityState === 'hidden') {
        hiddenAt.current = Date.now();
        return;
      }
      if (needsUnlock(hiddenAt.current, Date.now())) {
        setLocked(true);
        void unlock();
      }
      hiddenAt.current = null;
    };
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, [unlock]);

  if (!locked) return null;
  return (
    <div className="app-lock">
      <div className="login-wrap">
        <div className="login-head">
          <Logo variant="full" className="login-logo" />
        </div>
        <div className="login-card">
          <div className="form">
            {failed && <div className="banner crit">Не удалось подтвердить, что это вы</div>}
            <button type="button" className="btn primary wide" onClick={() => void unlock()}>
              Разблокировать
            </button>
            <button type="button" className="btn link" onClick={onLogout}>
              Выйти
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
